export default class FoldOnLoad {
  constructor() {
    this.getDomElements()

    if (!this.dom.header) return

    this.init()
  }

  init() {
    if (this.dom.statusBar) {
      this.dom.statusBar.classList.add('is-active')

      if (this.dom.heroBanner) {
        setTimeout(() => {
          this.dom.heroBanner.classList.add('is-active')
        }, 450)
      }
    } else {
      if (this.dom.heroBanner) {
        this.dom.heroBanner.classList.add('is-active')
      }
    }

    if (this.dom.mainContent && this.dom.heroBanner) {
      setTimeout(() => {
        this.dom.mainContent.classList.add('is-active')
      }, this.dom.statusBar ?  900 : 675)
    } else if (this.dom.mainContent) {
      setTimeout(() => {
        this.dom.mainContent.classList.add('is-active')
      }, this.dom.statusBar ?  450 : 225)
    }

    this.dom.header.classList.add('is-active')
  }

  getDomElements() {
    this.dom = {
      'header': document.querySelector('.js-header'),
      'statusBar': document.querySelector('.js-status-bar'),
      'heroBanner': document.querySelector('.js-hero'),
      'mainContent': document.querySelector('.js-primary-content'),
    }
  }
}